import EventEmitter from "es6-event-emitter";
import template from "./../templates/sidebarComponent.dust";

import {
  CLICKED_SUPPLEMENT_READER,
  CLICKED_BACK_TO_MAIN_READER,
} from "./../../../common/analytics/analyticsevents";

export default class SidebarComponent extends EventEmitter {
  constructor(appState, pubStore, publications = [], options) {
    super();
    this._appState = appState;
    this._pubStore = pubStore;
    this._publications = publications;
    this._DOMContainer = document.getElementById("sidebar");
    this._pubStore.on("pubStore:pubLoaded", this._hideCurrentPub);
    this._options = options;
  }

  render(publications) {
    if (!this._DOMContainer) return;
    if (publications) this._publications = publications;

    if (this._publications.length <= 1) {
      document.getElementById("reader-container").classList.add("no-sidebar");
      return;
    }
    const context = {
      publications: this._publications,
      displayLabel: this._options.displayPublicationNameInSidebar,
    };
    document.getElementById("sidebar").classList.remove("hidden");
    Dust.render(template, context, this._renderDone.bind(this));
  }

  destroy() {
    $(".sidebar-component .publications").off(
      "click",
      ".publication",
      this._onPublicationClickHandler
    );
    this._pubStore.off("pubStore:pubLoaded", this._hideCurrentPub);
    this._DOMContainer.innerHTML = "";
  }

  /////////////

  _renderDone(err, result) {
    if (err) return;
    this._DOMContainer.innerHTML = result;
    this._hideCurrentPub();
    this._attachEventListeners();
  }

  _hideCurrentPub = () => {
    const currenPublicationId = this._appState.publicationId;
    const currentPubcationNode = document.getElementById(
      `publication-${currenPublicationId}`
    );

    $(".sidebar-component .publication").removeClass("hidden");
    if (currentPubcationNode) currentPubcationNode.classList.add("hidden");
  };

  _attachEventListeners() {
    $(".sidebar-component .publications").off(
      "click",
      ".publication",
      this._onPublicationClickHandler
    );
    $(".sidebar-component .publications").on(
      "click",
      ".publication",
      this._onPublicationClickHandler
    );
  }

  _onPublicationClickHandler = (e) => {
    const publicationId = e.currentTarget.dataset.publicationId;
    const contentPackageId = e.currentTarget.dataset.cpId;
    const publicationType = e.currentTarget.dataset.publicationType;
    this.trigger("sidebar:publicationChanged", {
      publicationId,
      contentPackageId,
    });

    if (publicationType === "Main") {
      this._appState.triggerEvent(CLICKED_BACK_TO_MAIN_READER);
    } else {
      /*Xiti and Xcense uses the name and publication date of the selected supplement */
      const supplName = this._getSupplementName(
        this._publications,
        contentPackageId,
        publicationId
      );
      const supplPubDate = this._getSupplPublicationdate(
        this._publications,
        contentPackageId
      );
      const analyticsExtraData = {
        selectedSection: supplName,
        selectedEditionPubDate: supplPubDate,
      };
      this._appState.triggerEvent(
        CLICKED_SUPPLEMENT_READER,
        analyticsExtraData,
        true
      );
    }
  };

  _getSupplementName(supplements, cpID, pubID) {
    let supplementName = "";
    supplements.forEach((supplement) => {
      if (
        supplement.ContentPackageId == cpID &&
        supplement.PublicationId == pubID
      ) {
        supplementName = supplement.label;
      }
    });
    return supplementName;
  }

  _getSupplPublicationdate(editions, cpID) {
    let editionDate = "";
    editions.forEach((edition) => {
      if (edition.ContentPackageId == cpID) {
        editionDate = edition.PublicationDate;
      }
    });
    return editionDate;
  }
}



// WEBPACK FOOTER //
// ./src/web/reader/components/sidebarComponent.js